import axios from 'axios'
import { createStore } from 'vuex'
import Calendar from './calendar.js'
import Yoyaku from './yoyaku.js'

// axios.defaults.baseURL = 'http://tmerp.local/wp-json/tmr/v1'
// process.env.NODE_ENVによって接続先を変更
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'https://tokusawaen.xsrv.jp/wp/wp-json/tmr/v1'
} else {
  axios.defaults.baseURL = 'http://tmerp.local/wp-json/tmr/v1'
}
// axios.defaults.baseURL = 'https://tokusawaen.xsrv.jp/wp/wp-json/tmr/v1'

export default createStore({
  state: {
    today: '',
    ready: false,
    processing: false,
    pageTitle: '',
    pageTitleEng: '',
    setting: {}
  },
  getters: {
    today: state => state.today,
    ready: state => state.ready,
    processing: state => state.processing,
    pageTitle: state => state.pageTitle,
    pageTitleEng: state => state.pageTitleEng,
    setting: state => state.setting
  },
  mutations: {
    today (state, today) {
      state.today = today
    },
    ready (state, ready) {
      state.ready = ready
    },
    processing (state, processing) {
      state.processing = processing
    },
    pageTitle (state, pageTitle) {
      state.pageTitle = pageTitle
      document.title = pageTitle
    },
    pageTitleEng (state, pageTitleEng) {
      state.pageTitleEng = pageTitleEng
    },
    setting (state, setting) {
      state.setting = setting
    }
  },
  actions: {
    setPageTitle ({ commit }, title) {
      commit('pageTitle', title)
    },
    setPageTitleEng ({ commit }, title) {
      commit('pageTitleEng', title)
    },
    // 設定取得(ブラキャン)
    async getBracanSettings ({ commit }) {
      return new Promise((resolve) => {
        axios
          .get('/bracan/settings')
          .then((response) => {
            commit('setting', response.data)
            // console.log('settings loaded')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            commit('ready', true)
          })
      })
    },
    // 設定取得(レンタルテント)
    async getRentaltentSettings ({ commit }) {
      return new Promise((resolve) => {
        axios
          .get('/rentaltent/settings')
          .then((response) => {
            commit('setting', response.data)
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            commit('ready', true)
          })
      })
    }
  },
  modules: {
    Calendar,
    Yoyaku
  }
})
